import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Header from "../../../../components/molecules/Header";
import useStyles from "./style";
import { useSnackbar } from "notistack";

import {
  Container,
  Button,
  OutlinedInput,
  InputLabel,
  FormControl,
  Divider,
  FormHelperText,
  CircularProgress,
  Avatar,
} from "@material-ui/core";

import { useData } from "../../../../components/firebase/DataProvider";

import Gap from "../../../../components/atoms/Gap";

const defaultLogo = require("../../../../assets/images/landing-image-third.png");

const UbahProfilSeller = () => {
  const classes = useStyles();
  const { phone, profil, profilRef, webstore, level } = useData();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [isSubmitting, setSubmitting] = useState(false);
  const [currentName] = useState(profil.nama);

  const [currentWebstore] = useState({
    domain: `https://${webstore.domain}.tokorame.store`,
  });

  const [values, setValues] = useState({
    nama: "",
    errorStatus: false,
    errorType: "",
    errorMessage: "",
  });

  useEffect(() => {
    init();
  }, []);

  const init = useCallback(async () => {
    setValues({
      nama: profil.nama ? profil.nama : "",
    });
  });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStatus: false,
      errorType: "",
      errorMessage: "",
    });
  };

  const handleError = (err) => {
    setValues({
      ...values,
      errorStatus: true,
      errorType: err,
      errorMessage: err === "nama" ? "Nama wajib diisi" : null,
    });
  };

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const { nama } = values;

      if (!nama) {
        throw new Error("nama");
      }

      await profilRef.set(
        {
          nama: nama,
        },
        { merge: true }
      );

      history.goBack();

      enqueueSnackbar("Profil Berhasil Diupdate", {
        variant: "success",
      });
    } catch (err) {
      setSubmitting(false);
      console.log(err.message);
      handleError(err.message);
    }
    setSubmitting(false);
  });

  return (
    <>
      <Header
        type="with-title"
        title="Ubah Profil Seller"
        onClick={() => history.goBack()}
      />
      <Container>
        <div className={classes.wrapHeader}>
          <div className={classes.wrapAvatar}>
            <Avatar
              className={classes.large}
              src={!webstore.logo ? defaultLogo : webstore.logo}
            />
          </div>
          <Gap width={16} />
          <div>
            <p>{currentName}</p>
            <p>{phone?.id}</p>
            {level.is_active ? (<p>{currentWebstore.domain}</p>) : (<p>-</p>)}
          </div>
        </div>
        <Divider />
        <div className={classes.content}>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.input_form}
              disabled={isSubmitting}
              style={{ marginBottom: "25px" }}
              error={
                values.errorStatus
                  ? values.errorType === "nama"
                    ? values.errorStatus
                    : null
                  : null
              }
            >
              <InputLabel htmlFor="outlined-adornment-nama">Nama</InputLabel>
              <OutlinedInput
                value={values.nama}
                id="outlined-adornment-nama"
                label="Nama"
                placeholder="Kuma"
                onChange={handleChange("nama")}
              ></OutlinedInput>
              {values.errorStatus ? (
                values.errorType === "nama" ? (
                  <FormHelperText>{values.errorMessage}</FormHelperText>
                ) : null
              ) : null}
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              style={{
                position: "relative",
                letterSpacing: "1px",
                fontWeight: "bold",
                borderRadius: "8px",
                paddingTop: "12px",
                paddingBottom: "12px",
                bottom: 0,
                left: 0,
                width: "100%",
              }}
            >
              {isSubmitting === true && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
              {!isSubmitting ? "simpan" : null}
            </Button>
          </form>
        </div>
      </Container>
    </>
  );
};

export default UbahProfilSeller;
